import {
  Button,
  ButtonGroup,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import React, { useRef, useState } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { useForm } from 'react-hook-form';
import { FaPen, FaTimes } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import {
  deleteGoalTemplate,
  saveGoalTemplate,
} from '../../../stores/slices/fourBoxesTemplates/fourBoxesTemplatesActions';
import DeleteAlert from '../../Alerts/DeleteAlert';
import * as yup from 'yup';

const Goals = ({ templateId, category }) => {
  const schema = yup
    .object({
      goalItem: yup.string().required('Description is required'),
    })
    .required();
  const [isDeleting, setIsDeleting] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const cancelRef = useRef();
  const toast = useToast();
  const dispatch = useDispatch();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpenAlert,
    onOpen: onOpenAlert,
    onClose: onCloseAlert,
  } = useDisclosure();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSaveItem = async data => {
    await dispatch(
      saveGoalTemplate({
        goalItem: data.goalItem,
        goalCategoryTemplateId: category.id,
        templateId,
        isCreating: false,
        id: selectedTemplate.id,
      })
    );
    reset();
    onClose();
    toast({
      description: 'Item has been edited',
      colorScheme: 'primary',
      status: 'success',
      duration: 3000,
      isClosable: true,
      position: 'bottom-right',
      variant: 'primary',
    });
  };

  const onDeleteItem = async () => {
    setIsDeleting(true);
    const res = await dispatch(
      deleteGoalTemplate({ id: selectedTemplate?.id, category, templateId })
    );

    onCloseAlert();
    setIsDeleting(false);
    if (res.type === 'boxTemplate/deleteGoalTemplate/rejected') {
      toast({
        title: 'Something went wrong',
        description: 'Please try again later.',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
      });
    } else {
      setSelectedTemplate(null);
      toast({
        description: 'Template has been deleted',
        colorScheme: 'primary',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
        variant: 'primary',
      });
    }
  };
  return (
    <React.Fragment>
      <Scrollbars>
        <Flex overflowY="auto" flexDirection="column" flex={1} w={'full'}>
          {category.goal_templates.length > 0 ? (
            category.goal_templates.map((goal, i) => (
              <HStack
                px={'3'}
                bg={i % 2 === 0 ? 'secondary' : 'transparent'}
                justifyContent={'space-between'}
                key={goal.id}
              >
                <Text w={'full'} fontSize={'14px'} py={4}>
                  {goal.text}
                </Text>
                <ButtonGroup spacing="1" alignItems={'center'} color="primary">
                  <IconButton
                    aria-label="Edit"
                    icon={<FaPen />}
                    variant={'outline'}
                    size="sm"
                    color={'primary'}
                    onClick={() => {
                      setSelectedTemplate(goal);
                      onOpen();
                    }}
                  />
                  <IconButton
                    aria-label="Delete"
                    icon={<FaTimes />}
                    variant={'outline'}
                    size="sm"
                    color={'red.400'}
                    onClick={() => {
                      setSelectedTemplate(goal);
                      onOpenAlert();
                    }}
                  />
                </ButtonGroup>
              </HStack>
            ))
          ) : (
            <Text>No goal template yet.</Text>
          )}
        </Flex>
      </Scrollbars>

      {isOpen && (
        <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <form onSubmit={handleSubmit(onSaveItem)}>
              <ModalHeader>Edit goal template</ModalHeader>
              <ModalCloseButton />
              <ModalBody pb={6}>
                <FormControl id="goalItem" isInvalid={errors.goalItem}>
                  <FormLabel>Item Description</FormLabel>
                  <Input
                    id="goalItem"
                    defaultValue={selectedTemplate.text}
                    {...register('goalItem')}
                  />
                  <FormErrorMessage>
                    {errors.goalItem && errors.goalItem.message}
                  </FormErrorMessage>
                </FormControl>
              </ModalBody>

              <ModalFooter>
                <Button mr={3} type="submit" isLoading={isSubmitting}>
                  Save
                </Button>
                <Button
                  onClick={onClose}
                  variant="outline"
                  disabled={isSubmitting}
                >
                  Cancel
                </Button>
              </ModalFooter>
            </form>
          </ModalContent>
        </Modal>
      )}
      <DeleteAlert
        isOpen={isOpenAlert}
        cancelRef={cancelRef}
        onClose={onCloseAlert}
        isDeleting={isDeleting}
        header={`Delete goal template?`}
        body={
          "Are you sure? If you proceed with the deletion, it'll be gone forever."
        }
        onDeleteItem={onDeleteItem}
      />
    </React.Fragment>
  );
};

export default Goals;
